export default "__VITE_ASSET__yxyz0tFa__"